import { XX } from './XX';
import { IT } from './IT';

let Localization: any = {
    XX,
    IT
}

export default Localization;